import { Subject, Subscription } from 'rxjs';

import { Dimension2D, Rectangle } from '../../../../types/geo.types';
import { GeoUtils } from '../../../../utils/geo.utils';
import { HTMLUtils } from '../../../../utils/html.utils';
import { isEqual } from '../../../../utils/lodash-min';
import { RxUtils } from '../../../../utils/rx-utils';
import { AbstractEditTool } from './abstract-edit-tool';
import { CCanvas } from './ccanvas';
import { ImageContainer } from './image-container';
import { MoveResizeSquare } from './move_resize_square';
import { Photo } from './photo';

export class Crop extends AbstractEditTool {
    image_url = '';
    isImageReady = false;
    mrs: MoveResizeSquare = null;
    lastManuallyUpdateResults: Rectangle;
    listeners = new Array();
    events = new Array();
    photoModel: Photo;

    image_width;
    image_height;

    valueChanges: Subject<Rectangle>;
    cropFormGroup: any;// FormGroup; // TODO Preact need to fix this, ui crop presets not gonna work
    currentImageSize: Rectangle;
    subscription: Subscription;

    constructor(photoModel: Photo, container: ImageContainer) {
        super(container);
        this.photoModel = photoModel;
        this.valueChanges = new Subject();
    }

    async updateYImage(image?: HTMLImageElement): Promise<HTMLImageElement> {
        return null;
    }

    public updateImageDimensions(image) {
        this.image_width = image.naturalWidth;
        this.image_height = image.naturalHeight;
    }

    public async load(options?: any) {
        this.cropFormGroup = options.cropFormGroup;
        // this.image = await this.photoModel.populateXFromY(1200, true);

        // this.image_width = this.image.naturalWidth;
        // this.image_height = this.image.naturalHeight;
        // this.UI_updateImage(this.image);

        
        let rs = new MoveResizeSquare(this.container, this.valueChanges);
        rs.setResizeOptions(options.resizeOptionFormGroupValues);
        this.mrs = rs;
        // rs.init(this.valueChanges);
        this.showOverlay();
        this.container.notify('resize');
        this.fitMovableResizableSqureToCanvas();
        this.mrs.update_faded_area();
        this.updateOverlayCanvas();
        this.updateOriginalImageSize();  
        
        this.currentImageSize = this.mrs.getDim();
        this.subscription = this.valueChanges.subscribe({
            next: value => {
                const changed = !isEqual(this.currentImageSize, value);
                this.notifyHasChanges(changed);
            }
        });
        this.notifyHasChanges(false);
    }

    private updateOverlayCanvas() {
        // CCanvas.copyCanvas(this.photoModel.getEphemeralCanvas(), canvas);
        HTMLUtils.addClass(this.photoModel.getEphemeralCanvas(), 'relative');
    }

    public resizeMouseDown(e) {
        this.mrs.resizeMouseDown(e);
    }

    public mouseMove(e) {
        this.mrs.mouseMove(e);
        if (e.stopPropagation) { e.stopPropagation(); }
        if (e.preventDefault) { e.preventDefault(); }
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
    }

    /**
     * Try best to set the mrs's width or hight to given value and returns updated values
     * @param dimension 'width' or 'height'
     * @param value target value for given dimention
     */
    public setMRS(dimension: 'width' | 'height', value: { width: number, height: number, keepAspectRatio: boolean, ratio: { id: string }, resetTopLeft: boolean }) {// TODO Preact fix, this used to be a PSSelectDropdown option
        this.lastManuallyUpdateResults = this.mrs.tryUpdateArea(dimension, value[dimension], value.keepAspectRatio, value.ratio, value.resetTopLeft);
        return this.lastManuallyUpdateResults;
    }

    /**
     * Working
     * @param ratio
     */
    public fitMovableResizableSqureToImageWithRatio(selectedRatio: { id: string }) {// TODO Preact fix, this used to be a PSSelectDropdown option
        const ratio = this.mrs.decodeRatio(selectedRatio);
        const rect = GeoUtils.getChildRectAbsolutePostion(
            this.container.getElement().getBoundingClientRect(),
             this.mrs.getResizableElement().getBoundingClientRect()
            );

        let top = rect.top;
        let left = rect.left;
        let height = rect.height;
        let width = rect.width;

        if (rect.width * ratio.y / ratio.x < rect.height) {
            // this.mrs.getResizableElement().style.left = rect.left + 'px';
            // this.mrs.getResizableElement().style.width = rect.width + 'px';

            const newHeight = rect.width * ratio.y / ratio.x;
            const delta = rect.height - newHeight;

            top = (rect.top + delta / 2);
            height = newHeight;
            // this.mrs.getResizableElement().style.top = top + 'px';
            // this.mrs.getResizableElement().style.height = height + 'px';
        } else {
            // this.mrs.getResizableElement().style.top = rect.top + 'px';
            // this.mrs.getResizableElement().style.height = rect.height + 'px';

            const newWidth = rect.height * ratio.x / ratio.y;
            const delta = rect.width - newWidth;

            width = newWidth;
            left = (rect.left + delta / 2);

            // this.mrs.getResizableElement().style.left = left + 'px';
            // this.mrs.getResizableElement().style.width = width + 'px';
        }

        const newRect = {
            top: top,
            left: left,
            height: height,
            width: width,
        };

        this.mrs.updateArea(newRect);
        return newRect;
    }

    apply() {
        const dim: Dimension2D = this.cropFormGroup.value;
        if (dim.width !== this.photoModel.getEphemeralCanvas().width ||
            dim.height !== this.photoModel.getEphemeralCanvas().height) {
            const rect = this.cropFormGroup.value;
            CCanvas.crop(this.photoModel.getEphemeralCanvas(), rect);
            CCanvas.crop(this.photoModel.getPersistedCanvas(), rect);
            this.handleResizeEvent();
        }
    }

    resizeImage(size: { width: number, height: number }) {
        CCanvas.resize(this.photoModel.getEphemeralCanvas(), size);
        CCanvas.resize(this.photoModel.getPersistedCanvas(), size);
        this.handleResizeEvent();
    }

    public handleResizeEvent() {
        this.showOverlay();
        this.container.notify('resize');
        const rect = this.fitMovableResizableSqureToCanvas();
        this.mrs.update_faded_area();
        this.currentImageSize = this.mrs.getDim();
        this.valueChanges.next(rect);
    }

    public finalize() {
        // Driver.showLoading();
        this.hideOverlay();
        if (this.valueChanges) {
            this.valueChanges.complete();
        }
        // Remove events
        let event = null;
        while (event = this.events.pop()) {
            this.container.removeEventListener(event);
        }

        RxUtils.safeCloseSubscriber(this.subscription);
        return null;
    }

    private fitMovableResizableSqureToCanvas() {
        const canvas = this.photoModel.getEphemeralCanvas();
        const rect = GeoUtils.getChildRectAbsolutePostion(
            this.container.getElement().getBoundingClientRect(), 
            canvas.getBoundingClientRect()
        );


        // this.mrs.getResizableElement().style.top = rect.top + 'px';
        // this.mrs.getResizableElement().style.left = rect.left + 'px';
        // this.mrs.getResizableElement().style.width = rect.width + 'px';
        // this.mrs.getResizableElement().style.height = rect.height + 'px';
        this.mrs.updateArea(rect);
        return rect;
    }

    private hideOverlay() {
        this.mrs.getResizableElement().style.display = 'none';
        document.getElementById('top').style.display = 'none';
        document.getElementById('left').style.display = 'none';
        document.getElementById('right').style.display = 'none';
        document.getElementById('bottom').style.display = 'none';
    }

    private showOverlay() {
        this.mrs.getResizableElement().style.display = 'block';
        document.getElementById('top').style.display = 'block';
        document.getElementById('left').style.display = 'block';
        document.getElementById('right').style.display = 'block';
        document.getElementById('bottom').style.display = 'block';
    }
}
